import script from "./details.vue?vue&type=script&setup=true&name=ZoomEnhancedMediaDetails&lang=js"
export * from "./details.vue?vue&type=script&setup=true&name=ZoomEnhancedMediaDetails&lang=js"

import "./details.vue?vue&type=style&index=0&id=860437ca&lang=scss"

const __exports__ = script;

export default __exports__